import { createContext, useContext, type ReactNode } from 'react';

const IterableInitializedContext = createContext(false);

export function IterableInitializedProvider({
  children,
  isInitialized,
}: {
  children: ReactNode;
  isInitialized: boolean;
}) {
  return (
    <IterableInitializedContext.Provider value={isInitialized}>
      {children}
    </IterableInitializedContext.Provider>
  );
}

export function useIterableInitialized(): boolean {
  return useContext(IterableInitializedContext);
}
